(ns rothko.theme.manatee.editor.common
  (:require [garden.units :refer [px]]
            [rothko.theme.manatee.colours :refer [colours]]))

(def different
  {:different
   {:border [[(px 2) :solid (:red-bright colours)]]}})
